import React from "react";
import { iconProps } from "../Helper";

export const RemoveIcon = ({ className }: iconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      className={className}
    >
      <path
        d="M13.1364 2.94318H10.0682V1.20455C10.0682 1.05084 10.0035 0.903431 9.88845 0.794745C9.77337 0.686059 9.61729 0.625 9.45455 0.625H4.54545C4.38271 0.625 4.22663 0.686059 4.11155 0.794745C3.99647 0.903431 3.93182 1.05084 3.93182 1.20455V2.94318H0.863636C0.70089 2.94318 0.544809 3.00424 0.42973 3.11293C0.314651 3.22161 0.25 3.36902 0.25 3.52273C0.25 3.67643 0.314651 3.82384 0.42973 3.93253C0.544809 4.04121 0.70089 4.10227 0.863636 4.10227H1.54907L2.70945 12.8673C2.728 13.0075 2.80009 13.1364 2.91218 13.2299C3.02427 13.3234 3.16864 13.375 3.31818 13.375H10.6818C10.8314 13.375 10.9757 13.3234 11.0878 13.2299C11.1999 13.1364 11.272 13.0075 11.2905 12.8673L12.4509 4.10227H13.1364C13.2991 4.10227 13.4552 4.04121 13.5703 3.93253C13.6854 3.82384 13.75 3.67643 13.75 3.52273C13.75 3.36902 13.6854 3.22161 13.5703 3.11293C13.4552 3.00424 13.2991 2.94318 13.1364 2.94318ZM5.15909 1.78409H8.84091V2.94318H5.15909V1.78409ZM10.14 12.2159H3.86002L2.78616 4.10227H11.2138L10.14 12.2159Z"
        className={className}
        fill="#000000"
      />
    </svg>
  );
};
